import { request as umiRequest } from '@umijs/max';
import type { RequestOptions } from '@@/plugin-request/request';
import { BizAppConfig } from 'config/application.manifest';
import { getAccessToken } from './oauth2';
import { readCurrentTenantUuid } from '@/adapters/tenantStorage';

type ScopedRequestOptions = RequestOptions;

export const createRequest = (baseURL?: string) => {
  const scopedBaseURL = baseURL ?? BizAppConfig.appApiUrl ?? '';
  return <T = unknown>(url: string, options?: ScopedRequestOptions) => {
    const token = getAccessToken();
    const tenantUuid = readCurrentTenantUuid();

    const headers: Record<string, any> = {
      ...(options?.headers || {}),
    };

    if (token && !headers.Authorization && !headers.authorization) {
      headers.Authorization = `Bearer ${token}`;
    }
    if (tenantUuid && !headers['x-tenant-id']) {
      headers['x-tenant-id'] = tenantUuid;
    }

    if (!token && !url.includes('/auth/codeLogin') && !url.includes('/auth/refreshToken')) {
      console.warn(
        `⚠️ [createRequest] 发起请求 "${url}" 时未检测到有效 Token，请确认是否已完成登录。当前存储中无 access_token 或 token。`,
      );
    }

    return (
      umiRequest as unknown as <R = unknown>(
        requestUrl: string,
        requestOptions?: ScopedRequestOptions,
      ) => Promise<R>
    )<T>(url, {
      baseURL: scopedBaseURL,
      ...(options || {}),
      headers,
    });
  };
};

export const createAppRequest = () => createRequest(BizAppConfig.appApiUrl);
export const createTenantManagementRequest = () => createRequest(BizAppConfig.appTenantManagementUrl);
